<template>
  <div v-if="show">

    <weex-text
      class="item-heading"
      v-html="instructionHeading"
      ></weex-text>

    <div class="margin-left-20 margin-right-20">
      <div
        class="item-row-alignment margin-top-10"
        v-for="(instruction,index) in instructions"
        :key="instruction + index">
        <weex-text class="text-color-gray font-size-sm-base">
          {{index+1}}.&nbsp;
        </weex-text>
        <weex-text
          class="text-color-gray font-size-sm-base"
          v-html="instruction"
          ></weex-text>
      </div>
    </div>


    <wxc-button
      v-if="displayContinueButton"
      text="Continue"
      class="button_horizontal_center margin_top_40"
      type="blue"
      @wxcButtonClicked="onContinueClicked"
      ></wxc-button>
  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import EzUtils from "../../utils/EzUtils";

  export default {
    name: 'KycOptionsItem',
    components: { WxcButton },

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      sdkDetails: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },

    methods: {
      onContinueClicked() {
        if(EzUtils.isTrue(this.allowCompleteStage)) {
          this.$emit("onCompleted")
        } else {
          this.$emit("onGoToHomePage")
        }
      }
    },

    computed: {
      instructionHeading() {
        return this.sdkDetails && this.sdkDetails.instructionHeading
          ? this.sdkDetails.instructionHeading
          : "";
      },

      instructions() {
        return this.sdkDetails && this.sdkDetails.instructions
          ? this.sdkDetails.instructions
          : [];
      },

      displayContinueButton() {
        return this.sdkDetails
            ? EzUtils.isTrue(this.sdkDetails.displayContinueButton)
            : true;
      },

      allowCompleteStage() {
        return this.sdkDetails
            ? EzUtils.isTrue(this.sdkDetails.allowCompleteStage)
            : false;
      },
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
